var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCheckedOutlineIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.3754 4.45312H19.7371C19.5074 4.45312 19.2894 4.55859 19.1488 4.73906L9.48554 16.9805L4.85194 11.1094C4.78185 11.0204 4.6925 10.9484 4.59061 10.8989C4.48873 10.8494 4.37695 10.8236 4.26366 10.8234H2.62538C2.46835 10.8234 2.38163 11.0039 2.47772 11.1258L8.89725 19.2586C9.19725 19.6383 9.77382 19.6383 10.0762 19.2586L21.523 4.75313C21.6191 4.63359 21.5324 4.45312 21.3754 4.45312Z",
    fill: "#002979"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckedOutlineIcon);
export default __webpack_public_path__ + "static/media/checked-outline-icon.03820783a8949beb70b798997e8c7ce5.svg";
export { ForwardRef as ReactComponent };